import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type VariantePulsante = 'primario' | 'secondario' | 'neutro' | 'distruttivo';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VariantePulsante;
  /** Azione in scheda o riga: 44 px sul tattile, 28 px sul compatto. */
  minore?: boolean;
  /** Azione negli elenchi dell'area DT: 52 px sul tattile, 34 px sul compatto. */
  medio?: boolean;
  /** Azione principale a tutta larghezza: 60 px sul tattile, 44 px sul compatto. */
  grande?: boolean;
  largo?: boolean;
  children: ReactNode;
}

/**
 * Le varianti in uso nelle schermate applicate.
 *
 * Il catalogo del Sistema Visivo ne dichiara tre, ma le schermate ne impiegano una quarta
 * — grigia — per le azioni di arretramento, cinquantaquattro volte in tutte e quattro le
 * aree. Dove il catalogo e le schermate applicate divergono valgono le seconde
 * (PIANO.md § 6.12).
 *
 * Il distruttivo sta in punta di penna a riposo e si riempie solo alla sovrapposizione:
 * nessuna azione irreversibile deve essere raggiungibile per distrazione.
 */
export function Pulsante({
  variante = 'primario',
  minore = false,
  medio = false,
  grande = false,
  largo = false,
  className,
  type = 'button',
  children,
  ...resto
}: Props) {
  const classi = [
    'pulsante',
    `pulsante--${variante}`,
    minore && 'pulsante--minore',
    medio && 'pulsante--medio',
    grande && 'pulsante--grande',
    largo && 'pulsante--largo',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classi} {...resto}>
      {children}
    </button>
  );
}
